import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleCheck as check } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useApi from '../../hooks/useApi';
import './ExhibitorListByEvent.css';
import ExhibitorCard from './ExhibitorCard';
import { useNavigate, useParams } from 'react-router-dom';
import Form from '../common/Form';
import { userSet } from '../../store/userSlice';
import { get } from '../../utils/api';
//
// Раньше это была стартовая страница участника,
// а теперь мы переделали её для вывода экспонентов участника/агента по мероприятию.
//
const ExhibitorListByEvent = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { event } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
	const user = useSelector(state => state.auth.user);
    const [ limit, setLimit ] = useState(0);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ admin: user._id, event });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/exhibitors', params });
    // eslint-disable-next-line
    const [ eventData, eventError, isEventLoading ] = useApi({ type: 'get', method: `/events/${event}`});

    // Для агента узнаем сколько можно создавать экспонентов
    useEffect(() => {
        const fetchData = async (agent, event) => {
			const method = '/agent2event';
			const params = { agent, event };
			const result = await get(method, params);
			if(result.data) {
                setLimit(result.data.agent2event[0].limit);
			} else {
				setLimit(0);
            }
		};
        if(user?.role === 'agent') fetchData(user._id, event);
    }, [ user, event ]);

    const addExhibitor = () => {
        dispatch(userSet(user));
        navigate(`/cabinet/exhibitoradd/${event}`);
    };

	return (
    <div>
        {eventData && <h1>{eventData.event.name[lang]}</h1>}
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('common.loading')}</div>}
        {data && <React.Fragment>
            {data.exhibitors.length > 0 ?
            <React.Fragment>
                <div className='ExhibitorListByEvent-subtitle '>
                    <div>
                        <Icon icon={check} size='xl' className='icon'/>
                        <span
                            dangerouslySetInnerHTML={
                                {__html: t(`home.subtitle_${user.role}_1`, { 'interpolation': {'escapeValue': false} })}
                            }
                        />
                    </div>
                    <div>
                        <Icon icon={check} size='xl' className='icon'/>
                        <span
                            dangerouslySetInnerHTML={
                                {__html: t(`home.subtitle_${user.role}_2`, { 'interpolation': {'escapeValue': false} })}
                            }
                        />
                    </div>
                </div>

                <div className='grid'>
                {data.exhibitors.map(item => <ExhibitorCard key={item._id} exhibitor={item}/>)}
                </div> 
            </React.Fragment> : <p>{t('home.noexhibitors')}</p>}
        </React.Fragment>}

        {/* Кнопку добавления экспонента показываем только агенту если лимит не превышен */}
        {(user.role === 'agent' && limit > data?.exhibitors?.length) &&
        <Form>
            <input
                type='submit'
                value={t('e2e.add')}
                onClick={() => addExhibitor()}
            />
        </Form>}

        {user.role === 'agent' && <p className='gray'>{t('home.agent_can_add')}{limit - data?.exhibitors?.length}</p>}
    </div>
	);
};

export default ExhibitorListByEvent;
